module.exports = {"api_url_load":"https://api.b-chemzhiyun.com/resources/","api_url":"https://api.b-chemzhiyun.com/resources/request/","api_report_url":"https://api.b-chemzhiyun.com/resources/request/"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = DEN3
// module chunks = 173